import * as Sentry from "@sentry/react";

const ENV = process.env.REACT_APP_NODE_ENV === "production" ? "production" : "development";


Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN, 
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: ENV === "production" ? 1.0 : 0.0, 
  replaysSessionSampleRate: ENV === "production" ? 0.1 : 0.0, 
  replaysOnErrorSampleRate: ENV === "production" ? 1.0 : 0.0, 
  environment: ENV, 
});